document.addEventListener('DOMContentLoaded', function () {

    // ADBLOCK DETECTION, must identify the sneaky beaky adblock users and show them a different toplist.
    setTimeout(function () {
        const detect = document.querySelector('#detect');
        let adClasses = ["ad", "ads", "adsbox", "ad-placement", "doubleclick", "ad-placeholder", "ad-badge", "ad_holder", "ad_buttons", "adv", "advert", "advertisement", "banner", "ad-300x600", "ad-sidebar", "ad-unit", "ad-util", "footerads", "ads-lazy", "peel-ads", "adserver", "adrotate", "auto-ads"];

        // Add ad-related classes to the detection element
        for (let item of adClasses) {
            detect.classList.add(item);
        }

        // Check the computed style to detect adblock
        let getProperty = window.getComputedStyle(detect).getPropertyValue("display");

        if (getProperty == 'none') {  // Adblock detected

            const repeaters = document.querySelectorAll('.casino-repeater');

            repeaters.forEach(repeater => {
                // Get all children with the class `casino-item` and convert to an array
                const items = Array.from(repeater.querySelectorAll('.casino-item'));

                // Separate items based on their weight attribute
                const weightedItems = items.filter(item => item.getAttribute('weight') === "1");
                const otherItems = items.filter(item => item.getAttribute('weight') !== "1");

                // Clear the existing content of the repeater
                repeater.innerHTML = '';

                // Append weighted items first, preserving their order
                weightedItems.forEach(item => repeater.appendChild(item));

                // Append the other items, preserving their order
                otherItems.forEach(item => repeater.appendChild(item));
            });

        } else {  // No adblock detected

        }
    }, 500);  // Delay in milliseconds (500 ms = 0.5 seconds)

    // Script to handle the burger button toggle
    document.getElementById('burger-button').addEventListener('click', function () {

        const burgerButton = document.getElementById('burger-button');
        const mobileMenu = document.querySelector('#mobile-head .header-nav');

        // Toggle the burger button between burger and X
        burgerButton.classList.toggle('open');

        // Force a reflow to ensure the height is calculated
        if (!mobileMenu.classList.contains('show')) {
            mobileMenu.style.height = mobileMenu.scrollHeight + 'px'; // Set the height to content's height
            mobileMenu.offsetHeight; // This forces the browser to reflow and apply the height
            mobileMenu.classList.add('show');
        } else {
            mobileMenu.style.height = 0; // Collapse the menu
            mobileMenu.classList.remove('show');
        }
    });

    const carousels = document.querySelectorAll('.casino-carousel');
    carousels.forEach((carousel) => {
        new Glide(carousel, {
            type: 'carousel',
            perView: 4,
            gap: 10,
            startAt: 0.1, // Start at the second slide (0-based index)
            breakpoints: {
                992: {
                    perView: 3.1, // Adjust perView for screens <= 768px
                    gap: 8      // Optional: Adjust gap for this breakpoint
                },
                768: {
                    perView: 2.2, // Adjust perView for screens <= 768px
                    gap: 8      // Optional: Adjust gap for this breakpoint
                },
                480: {
                    perView: 1.3, // Adjust perView for screens <= 380px
                    gap: 5      // Optional: Adjust gap for this breakpoint
                }
            }
        }).mount();
    });

});